import React, { useState } from 'react';
import { Button, Typography } from "@material-ui/core";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPaperclip} from "@fortawesome/free-solid-svg-icons";

function AttachmentUploader({ onAttachmentSelected, defaultValue, onImageRemoved = () => {} }) {
    const [attachment, setAttachment] = useState(null);

    const handleChange = (event) => {
        const file = event.target.files[0];
        if (file && file.type.startsWith('application/')) {
            setAttachment(URL.createObjectURL(file));
            onAttachmentSelected(file); // Appel vers le parent
        }
    };

    const handleRemove = () => {
        setAttachment(null);
        onImageRemoved(); // Appel vers le parent
    };

    // Si une valeur par défaut est fournie, on l'utilise
    React.useEffect(() => {
        if (defaultValue) {
            setAttachment(defaultValue);
            onAttachmentSelected(defaultValue); // Appel vers le parent
        }
    }, [defaultValue]);

    return (
        <div>
            <input
                accept="application/*"
                id="upload-attachment"
                type="file"
                style={{ display: 'none' }}
                onChange={handleChange}
            />
            <label htmlFor="upload-attachment">
                <Button variant="contained" component="span">
                    <FontAwesomeIcon icon={faPaperclip} style={{ marginRight: 8 }} />
                    {attachment ? 'Pièce jointe' : 'Pièce jointe'}
                </Button>
            </label>

            {attachment && (
                <div style={{ marginTop: 16 }}>
                    <Typography variant="subtitle1">Pièce jointe attachée</Typography>
                </div>
            )}
        </div>
    );
}

export default AttachmentUploader;
